export default {
  title: 'Traccia ordine',
};
